import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {getSettingsColors} from '../SettingsDesign';

const BotConditionCard = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0,
    width: '100%',
    padding: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: getSettingsColors(theme).inset,
    '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.mode === 'dark' ? getSettingsColors(theme).input : theme.palette.background.paper,
        border: 0,
        borderRadius: 8,
        '&:focus-within': {outline: `1px solid ${theme.palette.primary.main}`},
        '&.Mui-error': {outline: `1px solid ${theme.palette.error.main}`}
    },
    '& .MuiOutlinedInput-notchedOutline': {border: 0},
    '& .MuiButton-root': {borderRadius: 6, whiteSpace: 'nowrap'},
    '& .MuiFormControlLabel-root': {marginRight: theme.spacing(2)},
    '& .MuiFormControlLabel-label': {whiteSpace: 'normal', fontSize: 13}
}));

export default BotConditionCard;
